import { _ } from '_core';

import { DraftParams } from './types';

export const validate = (params: DraftParams) => {
  if (_.some(params.analysis_pipelined_signals, (s) => _.isNil(s.signal_id)))
    return ['Signal is required on each row.'];
  return [];
};
